var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderTop'),_c('RouterView'),(_vm.showFooter)?_c('Footer'):_vm._e(),_c('ProductsModal'),_c('RappersModal'),_c('RidersModal'),_c('FightersModal'),_c('NewsModal'),_c('NewsModalPoster'),_c('ModalFeedback'),_c('ModalCountry')],1)}
var staticRenderFns = []

export { render, staticRenderFns }